import { supabaseFetch } from "./supabaseClient";

/**
 * Search for collaborators by name. Excludes the current user.
 *
 * @param {string} query - Name search term
 * @param {string} excludeFirebaseUid - Firebase UID to exclude (current user)
 * @param {number} limit - Max results
 */
export async function searchCollaborators(query, excludeFirebaseUid, limit = 10) {
  const data = await supabaseFetch("/rpc/search_users_for_v1", {
    method: "POST",
    body: JSON.stringify({
      p_query: query,
      p_exclude_firebase_uid: excludeFirebaseUid || null,
      p_limit: limit,
    }),
  });

  return data.map((row) => ({
    id: row.firebase_uid,
    name: row.name,
  }));
}

/**
 * Get collaborators by their Firebase UIDs (batch lookup).
 *
 * @param {string[]} firebaseUids - Array of Firebase UIDs
 */
export async function getCollaboratorsByIds(firebaseUids) {
  if (!firebaseUids || firebaseUids.length === 0) return [];

  const data = await supabaseFetch("/rpc/get_users_by_firebase_uids_for_v1", {
    method: "POST",
    body: JSON.stringify({
      p_firebase_uids: firebaseUids,
    }),
  });

  return data.map((row) => ({
    id: row.firebase_uid,
    name: row.name,
  }));
}
